import { Suspense } from 'react';
import { useParams } from 'react-router-dom';

import { useBoundStore } from 'app/store';
import { Header } from 'shared/ui/header';

import { MobileForm } from './MobileForm';
import { ModalProvider } from './ModalProvider';
import { NextBtnContainer } from './NextBtnContainer';
import {
  간호간병_구리,
  간호간병통합서비스동의서,
  간호사교대제_구리,
  비급여_구리,
  비급여항목사전설명동의서,
  입원약정서,
  입원약정서_구리,
  입원전담전문의_구리,
} from './Temp';

export const MobileFormPage = () => {
  const { contentCode } = useParams();
  const processFormData = useBoundStore((state) => state.hsptlzForm.processFormData);

  return (
    <ModalProvider>
      <Header />
      <MobileForm>
        <Suspense>
          {/* <MobileForm.Template html={간호사교대제_구리} /> */}
          {/* <MobileForm.Template html={간호간병_구리} /> */}

          {/* <MobileForm.Template html={입원전담전문의_구리} /> */}
          {/* <MobileForm.Template html={비급여_구리} /> */}
          {/* <MobileForm.TemplateContainer html={입원약정서_구리} /> */}
          {/* <MobileForm.Template html={비급여항목사전설명동의서} /> */}
          <MobileForm.TemplateContainer html={processFormData[contentCode].mobileTemplate} />
          <MobileForm.Modal />
          <NextBtnContainer />
        </Suspense>
      </MobileForm>
    </ModalProvider>
  );
};
